// แถวอีเมลผู้รับสิทธิ์ (ซื้อคอร์สให้พนักงาน / ผู้เข้าอบรม Onsite) — ใช้ร่วมกันระหว่างหน้าสมัครคอร์สและตะกร้า
export type RowStatus = 'idle' | 'searching' | 'ok' | 'notfound' | 'enrolled' | 'error'

export interface EmailRow {
  email: string
  status: RowStatus
  name?: string
}

export const emptyRow = (): EmailRow => ({ email: '', status: 'idle' })
